(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description"] && !Shopify.designMode) return;
  try {
    const ProductDescriptionVariants = () => {
		function initContainer(container) {
			const sectionId = container.dataset.sectionId;

			if (!sectionId) {
				return;
			}

			const jsonEl = container.querySelector("[data-product-description-variants]");
			const variantDescriptions = jsonEl ? JSON.parse(jsonEl.textContent) : {};

			jsonEl && jsonEl.remove();

			const defaultHtml = container.innerHTML;

			window.themeCore.EventBus.listen(`pdp:section-${sectionId}:change-variant`, ({ variant, variantId }) => {
				const id = variantId || (variant && variant.id);
				const html = id != null ? variantDescriptions[id] : void 0;

				container.innerHTML = html || defaultHtml;
			});
		}

		function init() {
			document.querySelectorAll("[data-js-product-description]").forEach(initContainer);
		}

		return Object.freeze({
			init
		});
	};
	const action = () => {
		window.themeCore.ProductDescriptionVariants = ProductDescriptionVariants();
		window.themeCore.utils.register(window.themeCore.ProductDescriptionVariants, "product-description-variants");
	};
	if (window.themeCore && window.themeCore.loaded) {
		action();
	} else {
		document.addEventListener("theme:all:loaded", action, { once: true });
	}
  } catch(e) { console.error(e); }
})();

})();
